import React from 'react';
import Children from '../../interfaces/children.interface';
import TestId from '../../interfaces/test-id.interface';

export interface Props extends Children, TestId {}

/** A loading indicator centered on the screen */
const LoadingIndicator = ({ children, testId }: Props): React.ReactElement => (
  <div
    className="
      flex
      flex-col
      items-center
      absolute
      left-1/2
      top-1/2
      transform
      -translate-x-1/2
      -translate-y-1/2
    "
    data-testid={testId}
  >
    <div className={`${children ? 'mb-4' : ''} loading-grid`}>
      <div className="loading-grid__item" />
      <div className="loading-grid__item" />
      <div className="loading-grid__item" />
      <div className="loading-grid__item" />
      <div className="loading-grid__item" />
      <div className="loading-grid__item" />
      <div className="loading-grid__item" />
      <div className="loading-grid__item" />
      <div className="loading-grid__item" />
    </div>
    {children && <div className="text-sm">{children}</div>}
  </div>
);

export default LoadingIndicator;
